/**
 * wireDebugCamera — Agent smoke for camera lock/follow (FID-HUD-02…06).
 */
import {
  createCameraState,
  toggleCameraLock,
  updateCameraState
} from '../../domain/camera.js';

function cameraHudState(state) {
  const locked = !!state.locked;
  return {
    hook: '__debugCamera',
    locked,
    follow: locked || !!state.spaceHeld,
    x: Number(state.x) || 0,
    z: Number(state.z) || 0
  };
}

/**
 * @param {{ globalObj?: object, getChampion?: () => { x: number, z: number } }} [opts]
 */
export function wireDebugCamera({
  globalObj = typeof globalThis !== 'undefined' ? globalThis : {},
  getChampion = () => ({ x: 0, z: 0 })
} = {}) {
  let state = createCameraState({ locked: true, x: 0, z: 0 });
  const api = {
    get: () => ({ ...state }),
    getState() {
      return cameraHudState(state);
    },
    toggleLock() {
      state = toggleCameraLock(state, getChampion());
      return { ...state };
    },
    setLock(locked) {
      if (!!locked === !!state.locked) return { ...state };
      state = toggleCameraLock(state, getChampion());
      return { ...state };
    },
    setLocked(locked) {
      api.setLock(locked);
      return cameraHudState(state);
    },
    followTick(dt = 0.016) {
      state = updateCameraState(state, {}, getChampion(), dt);
      return { ...state };
    }
  };
  globalObj.__debugCamera = api;
  return api;
}
